import { schema } from 'normalizr';

export const ENTITY_REDUCER_KEY = 'teams';

export const entity = new schema.Entity(ENTITY_REDUCER_KEY);
